import React, { Component } from 'react';

//views
import CariMainPgLoggedInHeaderView from "../../cari_template_view/CariMainPgLoggedInHeaderView";
import CariMainPgFooterView from "../../cari_template_view/CariMainPgFooterView";
import CariMainNavBarLayoutRouting from "./CariMainNavBarLayoutRouting";

//load generic functions
import {
    isEmpty
} from "../../../../../functions/generic_functions";

//router
import {
    Prompt,
    Route,
} from 'react-router-dom';


//get static routes
import {
    cari_home_pg_url,
} from "../../../../../router/static_routes";

/*
    props {
        siteTitle: site title
    }
*/
class CariMainPgLoggedIn extends Component {


    render() {
        return (
            <div>
                {/* <Prompt
                    when={this.checkNextUrlLocationIfNotFormPg()} //true activates, false disables
                    message={"There may be unsaved changes, are you sure you want to leave?"}
                /> */}

                <div id='container'>
                    <div id='page'>
                        {<Route
                            path={cari_home_pg_url}
                            component={CariMainNavBarLayoutRouting}
                            siteTitle={this.props.siteTitle}
                        />}
                        {/* <CariMainPgLoggedInHeaderView
                            siteTitle={this.props.siteTitle}
                        />  */}
                        {/* <div className='header-divider'>
                        </div> */}
                        
                        {/* <div
                            id='page-content'
                            className='no-navigation'
                        >
                            <section className='main'>
                                <div className="p-grid">
                                    <div className="p-col-12">
                                         
                                        <Route
                                            path={cari_home_pg_url}
                                            component={CariMainNavBarLayoutRouting}
                                            siteTitle={this.props.siteTitle}
                                        />

                                    </div>
                                </div>
                            </section>
                        </div> */}
                    
                        {/* <CariMainPgFooterView /> */}
                    </div>
                    
                </div>
                
            </div>
        );
    }
}
export default CariMainPgLoggedIn;
